/* Expert pop-up: opens from the plus button on each advisor card. */
(function () {
  'use strict';

  var FOCUSABLE =
    'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';

  function init(section) {
    if (section.dataset.cuftExpertsModalReady === 'true') return;
    section.dataset.cuftExpertsModalReady = 'true';

    var activeModal = null;
    var lastTrigger = null;
    var previousOverflow = '';

    function open(trigger) {
      var modal = section.querySelector(
        '#' + trigger.getAttribute('data-cuft-modal-open')
      );
      if (!modal) return;

      close();

      var card = trigger.closest('.cuft-section-experts__card') || trigger;
      var button = card.querySelector('.cuft-section-experts__card-expand') || trigger;

      activeModal = modal;
      lastTrigger = button;
      modal.hidden = false;
      button.setAttribute('aria-expanded', 'true');

      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';

      var dialog = modal.querySelector('.cuft-section-experts__modal-dialog');
      if (dialog) dialog.focus();
    }

    function close() {
      if (!activeModal) return;

      activeModal.hidden = true;
      activeModal = null;

      document.body.style.overflow = previousOverflow;

      if (lastTrigger) {
        lastTrigger.setAttribute('aria-expanded', 'false');
        lastTrigger.focus();
        lastTrigger = null;
      }
    }

    section.addEventListener('click', function (event) {
      if (!event.target.closest) return;

      var closer = event.target.closest('[data-cuft-modal-close]');
      if (closer && section.contains(closer)) {
        close();
        return;
      }

      var trigger = event.target.closest('[data-cuft-modal-open]');
      if (trigger && section.contains(trigger)) {
        event.preventDefault();
        open(trigger);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (!activeModal) return;

      if (event.key === 'Escape') {
        close();
        return;
      }

      if (event.key !== 'Tab') return;

      var dialog = activeModal.querySelector('.cuft-section-experts__modal-dialog');
      if (!dialog) return;

      var items = Array.prototype.filter.call(
        dialog.querySelectorAll(FOCUSABLE),
        function (el) {
          return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
        }
      );
      if (!items.length) return;

      var first = items[0];
      var last = items[items.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  function initNav(section) {
    if (section.dataset.cuftExpertsNavReady === 'true') return;

    var track = section.querySelector('.cuft-section-experts__track');
    var prev = section.querySelector('[data-cuft-scroll="prev"]');
    var next = section.querySelector('[data-cuft-scroll="next"]');
    if (!track || !prev || !next) return;

    section.dataset.cuftExpertsNavReady = 'true';

    function step() {
      var card = track.querySelector('.cuft-section-experts__card');
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function sync() {
      var max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= max - 1;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });

    next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  function boot() {
    Array.prototype.forEach.call(
      document.querySelectorAll('.cuft-section-experts'),
      function (section) {
        init(section);
        initNav(section);
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();